module.exports = __webpack_public_path__ + "img/icon-newpage.ad08d184.svg";